export default __webpack_public_path__ + "static/InterDisplay-ExtraLightItalic-51cff3ff52760d4e04cec8b84d845808.woff";